{
  "validation": {
    "required": "Ce champ est requis.",
    "invalid_type": "Type invalide, attendu '{{{expected}}}'.",
    "too_small": "La valeur est trop petite. Le minimum autorisé est '{{min}}'.",
    "too_big": "La valeur est trop grande. Le maximum autorisé est '{{max}}'.",
    "invalid_email": "Format d'email invalide.",
    "invalid_url": "Format d'URL invalide.",
    "invalid_date": "Format de date invalide.",
    "invalid_enum_value": "Sélection invalide. Les valeurs autorisées sont '{{values}}'.",
    "invalid_string": "Entrée invalide, chaîne attendue.",
    "invalid_number": "Entrée invalide, nombre attendu.",
    "passwordMustBeLongerThan": "Le mot de passe doit contenir plus de {{value}} caractères",
    "passwordMustBeShorterThan": "Le mot de passe doit contenir moins de {{value}} caractères",
    "passwordMustContainUppercase": "Le mot de passe doit contenir au moins une lettre majuscule",
    "passwordMustContainLowercase": "Le mot de passe doit contenir au moins une lettre minuscule",
    "passwordMustContainNumber": "Le mot de passe doit contenir au moins un chiffre",
    "passwordMustContainSpecialCharacter": "Le mot de passe doit contenir au moins un caractère spécial",
    "errors": {
      "invalid_type": "Attendu {{expected}}, reçu {{received}}",
      "invalid_type_received_undefined": "Requis",
      "invalid_literal": "Valeur littérale invalide, attendu {{expected}}",
      "unrecognized_keys": "Clé(s) non reconnue(s) dans l'objet : {{keys}}",
      "invalid_union": "Entrée invalide",
      "invalid_union_discriminator": "Valeur de discriminateur invalide. Attendu {options}",
      "invalid_enum_value": "Valeur d'énumération invalide. Attendu {{options}}, reçu {{received}}",
      "invalid_arguments": "Arguments de fonction invalides",
      "invalid_return_type": "Type de retour de fonction invalide",
      "invalid_date": "Date invalide",
      "custom": "Entrée invalide",
      "invalid_intersection_types": "Les résultats de l'intersection n'ont pas pu être fusionnés",
      "not_multiple_of": "Le nombre doit être un multiple de {{multipleOf}}",
      "not_finite": "Le nombre doit être fini",
      "invalid_key": "Clé invalide dans {{origin}}",
      "invalid_element": "Valeur invalide dans {{origin}}",
      "invalid_string": {
        "email": "{{validation}} invalide",
        "emoji": "{{validation}} invalide",
        "url": "{{validation}} invalide",
        "uuid": "{{validation}} invalide",
        "ulid": "{{validation}} invalide",
        "ip": "{{validation}} invalide",
        "cuid": "{{validation}} invalide",
        "cuid2": "{{validation}} invalide",
        "regex": "Invalide",
        "datetime": "{{validation}} invalide",
        "startsWith": "{{path}} doit commencer par {{startsWith}}",
        "endsWith": "{{path}} doit se terminer par {{endsWith}}"
      },
      "too_small": {
        "array": {
          "exact": "{{path}} doit contenir exactement {{minimum}} élément(s)",
          "inclusive": "{{path}} doit contenir au moins {{minimum}} élément(s)",
          "not_inclusive": "{{path}} doit contenir plus de {{minimum}} élément(s)"
        },
        "string": {
          "exact": "{{path}} doit contenir exactement {{minimum}} caractère(s)",
          "inclusive": "{{path}} doit contenir au moins {{minimum}} caractère(s)",
          "not_inclusive": "{{path}} doit contenir plus de {{minimum}} caractère(s)"
        },
        "number": {
          "exact": "{{path}} doit être exactement {{minimum}}",
          "inclusive": "{{path}} doit être supérieur ou égal à {{minimum}}",
          "not_inclusive": "{{path}} doit être supérieur à {{minimum}}"
        },
        "bigint": {
          "exact": "{{path}} doit être exactement {{minimum}}",
          "inclusive": "{{path}} doit être supérieur ou égal à {{minimum}}",
          "not_inclusive": "{{path}} doit être supérieur à {{minimum}}"
        },
        "set": {
          "exact": "Entrée invalide",
          "inclusive": "Entrée invalide",
          "not_inclusive": "Entrée invalide"
        },
        "date": {
          "exact": "La date doit être exactement {{minimum, date}}",
          "inclusive": "La date doit être supérieure ou égale à {{minimum, date}}",
          "not_inclusive": "La date doit être supérieure à {{minimum, date}}"
        }
      },
      "too_big": {
        "array": {
          "exact": "{{path}} doit contenir exactement {{maximum}} élément(s)",
          "inclusive": "{{path}} doit contenir au maximum {{maximum}} élément(s)",
          "not_inclusive": "{{path}} doit contenir moins de {{maximum}} élément(s)"
        },
        "string": {
          "exact": "{{path}} doit contenir exactement {{maximum}} caractère(s)",
          "inclusive": "{{path}} doit contenir au maximum {{maximum}} caractère(s)",
          "not_inclusive": "{{path}} doit contenir moins de {{maximum}} caractère(s)"
        },
        "number": {
          "exact": "{{path}} doit être exactement {{maximum}}",
          "inclusive": "{{path}} doit être inférieur ou égal à {{maximum}}",
          "not_inclusive": "{{path}} doit être inférieur à {{maximum}}"
        },
        "bigint": {
          "exact": "{{path}} doit être exactement {{maximum}}",
          "inclusive": "{{path}} doit être inférieur ou égal à {{maximum}}",
          "not_inclusive": "{{path}} doit être inférieur à {{maximum}}"
        },
        "set": {
          "exact": "Entrée invalide",
          "inclusive": "Entrée invalide",
          "not_inclusive": "Entrée invalide"
        },
        "date": {
          "exact": "La date doit être exactement {{maximum, date}}",
          "inclusive": "La date doit être inférieure ou égale à {{maximum, date}}",
          "not_inclusive": "La date doit être inférieure à {{maximum, date}}"
        }
      }
    },
    "validations": {
      "email": "email",
      "emoji": "emoji",
      "url": "url",
      "uuid": "uuid",
      "ip": "ip",
      "regex": "regex",
      "uuidv4": "UUIDv4",
      "uuidv6": "UUIDv6",
      "nanoid": "nanoid",
      "guid": "GUID",
      "cuid": "cuid",
      "cuid2": "cuid2",
      "ulid": "ULID",
      "xid": "XID",
      "ksuid": "KSUID",
      "datetime": "datetime ISO",
      "date": "date ISO",
      "time": "heure ISO",
      "duration": "durée ISO",
      "ipv4": "adresse IPv4",
      "ipv6": "adresse IPv6",
      "cidrv4": "plage IPv4",
      "cidrv6": "plage IPv6",
      "base64": "chaîne encodée en base64",
      "base64url": "chaîne encodée en base64url",
      "json_string": "chaîne JSON",
      "e164": "numéro E.164",
      "jwt": "JWT",
      "template_literal": "entrée"
    },
    "types": {
      "function": "fonction",
      "number": "nombre",
      "string": "chaîne",
      "nan": "nan",
      "integer": "entier",
      "float": "flottant",
      "boolean": "booléen",
      "date": "date",
      "bigint": "bigint",
      "undefined": "indéfini",
      "symbol": "symbole",
      "null": "null",
      "array": "tableau",
      "object": "objet",
      "unknown": "inconnu",
      "promise": "promesse",
      "void": "void",
      "never": "jamais",
      "map": "map",
      "set": "set"
    },
    "custom": {},
    "paymentMethodRequired": "Veuillez sélectionner un mode de paiement"
  },
  "appleSignIn": {
    "userCancelled": "La connexion a été annulée",
    "appleAuthFailed": "L'authentification Apple a échoué. Veuillez réessayer.",
    "backendFailed": "Impossible de finaliser la connexion. Veuillez réessayer.",
    "networkError": "Erreur réseau. Veuillez vérifier votre connexion et réessayer.",
    "unavailable": "La connexion Apple n'est pas disponible sur cet appareil",
    "invalidResponse": "Réponse invalide d'Apple. Veuillez réessayer.",
    "general": "Une erreur inattendue s'est produite. Veuillez réessayer."
  },
  "googleSignIn": {
    "general": "Une erreur inattendue s'est produite. Veuillez réessayer."
  },
  "appointment": {
    "tipUpdateFailed": "Échec de la mise à jour du pourboire",
    "promoCodeUpdateFailed": "Échec de l'application du code promo",
    "promoCodeRemoveFailed": "Échec de la suppression du code promo",
    "ratingUpdateFailed": "Échec de l'envoi de la note",
    "cancelFailed": "Échec de l'annulation de la commande",
    "unknownError": "Erreur inconnue"
  },
  "calendar": {
    "appleCalendarFailed": "Échec de l'ouverture d'Apple Calendar",
    "googleCalendarFailed": "Échec de l'ouverture de Google Calendar",
    "yahooCalendarFailed": "Échec de l'ouverture de Yahoo Calendar",
    "cannotOpenAppleCalendar": "Impossible d'ouvrir Apple Calendar",
    "cannotOpenGoogleCalendar": "Impossible d'ouvrir Google Calendar",
    "cannotOpenYahooCalendar": "Impossible d'ouvrir Yahoo Calendar",
    "appleCalendarNotAvailable": "Apple Calendar n'est pas disponible dans ce navigateur",
    "nativeCalendarNotAvailable": "Le calendrier natif n'est pas disponible sur cette plateforme",
    "unknownError": "Une erreur inattendue s'est produite. Veuillez réessayer."
  },
  "email": {
    "noEmailClient": "Aucun client de messagerie disponible. Veuillez installer une application de messagerie.",
    "failedToOpen": "Échec de l'ouverture du client de messagerie. Veuillez réessayer."
  },
  "cart": {
    "membershipPromoConflict": "Les codes promo ne sont pas cumulables avec votre remise d’abonnement"
  }
}
